import {
  EmailSuggestionConfig,
  EmailSuggestionListType,
} from '@nykaa/auth-shared/types/authScreen';
import { useSelector } from 'react-redux';
import { isEligible } from 'store/app/selector';
import { State } from 'store/types';

const useEmailSuggestion = () => {
  const emailSuggestion: EmailSuggestionConfig =
    useSelector(
      (state: State) => state.remoteConfig.configs.AB?.emailSuggestion
    ) || {};
  const appReducer = useSelector((state: State) => state.appReducer);
  const isEmailSuggestionEnabled = isEligible(emailSuggestion, appReducer?.run);
  let emailSuggestionList: EmailSuggestionListType = {};
  if (isEmailSuggestionEnabled) {
    emailSuggestionList = emailSuggestion.emailSuggestionList || {};
  }
  return {
    isEmailSuggestionEnabled,
    emailSuggestionList,
  };
};

export default useEmailSuggestion;
